import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import React from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { getDeskSupportLink } from '@/utils/urls';

type Props = {};

const SearchError = () => {
    const isMobile = useIsMobileLayout();

    return (
        <Caption
            className={cn(
                'h-[158px] w-full border border-border-secondary pt-2xl text-center tracking-[0.2px] [&_a]:cursor-pointer [&_a]:underline',
                { 'h-[127px] px-md pb-xl pt-md': isMobile }
            )}
            color="secondary"
        >
            <div>
                <FormattedMessage id="search_error_1" />
            </div>
            <div>
                <span>
                    <FormattedMessage id="search_error_2" />
                </span>
                <Link
                    href={getDeskSupportLink()}
                    rel="noopener"
                    target="_blank"
                >
                    <FormattedMessage id="search_error_contact_support" />
                </Link>
                <span>
                    <FormattedMessage id="search_error_3" />
                </span>
            </div>
        </Caption>
    );
};

export default React.memo<Props>(SearchError);
